import { ColumnDefWithFilters, ColumnGroup } from '../types'
import { useSimpleColumns } from '../utils'

const collectionGroups: ColumnGroup[] = [
  {
    id: 'exalted',
    header: 'Reputations',
    subColumns: [
      {
        id: 'total_exalted',
        header: 'Exalted',
        field: 'exalted_amount',
      },
    ],
  },
  {
    id: 'renown',
    header: 'Renown',
    rankFields: null,
    subColumns: [
      {
        label: 'Council of Dornogal',
        value: 'council_of_dornogal',
        max: 25,
      },
      {
        label: 'Assembly of the Deeps',
        value: 'assembly_of_the_deeps',
        max: 25,
      },
      { label: 'Hallowfall Arathi', value: 'hallowfall_arathi', max: 25 },
      { label: 'Severed Threads', value: 'severed_threads', max: 25 },
      { label: 'Cartels of Undermine', value: 'cartels_of_undermine', max: 20 },
      {
        label: 'Gallagio Loyalty Rewards Club',
        value: 'gallagio_loyalty_rewards_club',
        max: 20,
      },
      { label: 'The Karesh Trust', value: 'the_karesh_trust', max: 20 },
      { label: 'Manaforge Vandals', value: 'manaforge_vandals', max: 15 },
    ].map((reputation) => ({
      id: reputation.value,
      header: reputation.label,
      field: `${reputation.value}_renown`,
      cellWrapper: (value) => (
        <span className={value === reputation.max ? 'text-green-500' : ''}>
          {value}
        </span>
      ),
    })),
  },
]

export const useReputationsColumns = (): ColumnDefWithFilters => {
  const columns = useSimpleColumns(collectionGroups)

  return { columns, initialSortBy: [{ id: 'total_exalted', desc: true }] }
}
